import axios from "axios";
import { Message } from "view-design";
import store from "@/store/index";
// import router from "@/router/index";
import { refreshToken } from "api/user";
import { API_BASE_URL } from "@/utils/config";

// 刷新token
function getRefreshToken() {
  return refreshToken({ refreshToken: store.state.refreshToken });
}

// 刷新 token 接口地址（api/user.js 中 refreshToken 的实际 url）
const REFRESH_TOKEN_URL = "/hkweb/refreshToken";

// 创建一个axios实例
const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 300000,
});

// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
instance.setToken = (token) => {
  instance.defaults.headers["token"] = token;
  store.commit("c_token", token);
};

// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];
instance.defaults.headers.post["Content-Type"] = "application/json";
instance.interceptors.request.use((config) => {
  // config.async 默认异步调用统一一个loading 如需同步调用则设置false 自行设置loading
  config.isToken || (config.isToken = false);
  config.isToken &&
    store.state.token != "" &&
    (config.headers["Authorization"] = "bearer " + store.state.token);

  let expiration = store.state.expiration;
  let currentTime = new Date().getTime();
  const maxExpirationTime = 30 * 60 * 1000; // 距离过期前30分钟开始获取token

  if (expiration > 0 && expiration - currentTime > 0 && expiration - currentTime <= maxExpirationTime) {
    const isRefreshReq = config.url === REFRESH_TOKEN_URL;
    if (!isRefreshReq && !isRefreshing) {
      isRefreshing = true;
      getRefreshToken()
        .then((res) => {
          const { code, data } = res;
          if (code === 200 && data && data.accessToken) {
            store.commit("MUT_TOKEN_INFO", data);
            requests.forEach((cb) => cb(data.accessToken));
          } else {
            // 刷新失败：释放等待队列，避免所有在途请求永久挂起（否则刷新页面整片卡死）
            requests.forEach((cb) => cb(null));
          }
          requests = [];
          isRefreshing = false;
        })
        .catch(() => {
          requests.forEach((cb) => cb(null));
          requests = [];
          isRefreshing = false;
        });
    } else if (!isRefreshReq) {
      return new Promise((resolve) => {
        // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        requests.push((newToken) => {
          if (newToken) {
            config.headers["Authorization"] = "bearer " + newToken;
          }
          resolve(config);
        });
      });
    }
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "arraybuffer") {
      try {
        const enc = new TextDecoder("utf-8");
        let res = JSON.parse(enc.decode(new Uint8Array(response.data))); // 转化成json对象
        return res;
      } catch (error) {
        return {
          code: 200,
          data:
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            ),
          message: "",
        };
      }
    }
    const { code, message } = response.data;
    if (code === 3004 || code === 401 || code === 3002 || code === 3009) {
      if (isRefreshing) return response;
      isRefreshing = true;
      // 区分"已登录但 token 失效"与"本就没登录"：
      // 后者若也强制 reload，会形成 刷新→401→刷新 的死循环
      const hadToken = !!store.state.token;
      store.commit("MUT_LOGOUT");
      if (hadToken) {
        Message.warning("登录过期，请重新登录！");
        setTimeout(() => {
          isRefreshing = false;
          window.location.reload();
        }, 1000);
      } else {
        isRefreshing = false;
      }
      response.data.code = "hide";
      return response.data;
    }
    // config.toast 开启失败信息提示
    if (!response.config.noToast && code !== 200) {
      message && Message.warning(message);
      return Promise.reject(message);
    }
    return response.data;
  },
  (error) => {
    const status = error.response && error.response.status;
    let msg = "请稍后重试!";
    if (status === 502 || status === 504) {
      msg = "网关服务异常，请稍后重试";
    } else if (error.code === "ECONNABORTED" || /timeout/i.test(error.message || "")) {
      msg = "请求超时，请稍后重试";
    } else if (!error.response) {
      msg = "网络异常，请检查网络后重试";
    }
    Message.warning(msg);
    return Promise.reject(error);
  }
);
export default instance;
